import store from "@/state/store"
import axios from 'axios'

store.subscribe(mutation => {
    switch (mutation.type) {
        case 'keycloak/SET_TOKEN':
            if (mutation.payload) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
                localStorage.setItem('token', mutation.payload)
                document.cookie = `token=${mutation.payload}; max-age=${localStorage.getItem('tokenExpiresIn')}; path=/`;
                setTimeout(() => {
                    store.dispatch('keycloak/getRefreshToken')
                }, localStorage.getItem('tokenExpiresIn') * 1000)
            } else {
                axios.defaults.headers.common['Authorization'] = null
                localStorage.removeItem('token')
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('tokenExpiresIn')
                localStorage.removeItem('refreshTokenExpiresIn')                
            }
            break;
        case 'keycloak/SET_TOKEN_PARSED':
            if (store.getters['keycloak/authenticated']) {
                store.dispatch('sessao/listCategorias')
            }
            break;
    }
})